export default{
  menu_rename: 'Rename',
  menu_delete: 'Delete',
  menu_move_to: 'Move to',
  menu_add_to_favorites: 'Add to Favorites',
  menu_remove_to_favorites: 'Remove From Favorites',
  menu_add_to_favorites_successfully: 'Add to Favorites Successfully',
  menu_remove_from_favorites_successfully: 'has removed from Favorites',
  menu_dataset: 'DataSet',
  menu_edit: 'Edit',
  menu_order: 'Order',
  menu_new: 'New',
  menu_subscribe: 'Subscribe',
  subscribe_left_menu_management: 'Subscribe Management',
  menu_download: 'Download Guidelines',
  menu_new_menu: 'New menu',
  menu_new_folder: 'New folder',
  menu_new_subfolder: 'New subfolder',
  menu_new_dashboard: 'New dashboard',
  menu_download_guidelines: 'Download Guidelines',
  menu_shift_up: 'Shift up',
  menu_shift_down: 'Shift down',
  menu_confirm: 'Confirm',
  menu_cancel: 'Cancel',

  menu_info_move: 'Are you sure to move?',
  menu_info_fav_del: 'Are you sure to remove from Favorites?',
  menu_info_del_1: 'Delete the ',
  menu_info_del_2: 'Are you sure to delete the ',
  menu_info_del_3: 'The delete operation is irrevocable,Please confirm the operation.',
  menu_info_name_err: 'Only Chinese characters, letters, numbers and special characters (- _ < > " “ & : ’：\') are supported for input.',
  menu_info_name_exist: ' Name already exists, please modify',

  dashboard: 'Dashboard ', // 在这里增加空格, 是为了页面显示时, 两个英文单词之间有空格, 而中文不需要有空格
  dashboard_title: 'Dashboard',
  folder: 'Folder ',
  subfolder: 'Subfolder ',
  menu: 'Menu ',
  name: 'Name',
  chinese: 'Chinese ',
  menu_level: 'Level',
  menu_link: 'Link',
  menu_path_type_webhook_url: 'Tableau Default',
  menu_path_type_url: 'Other Tableau',
  menu_path_type_Path: 'Frame Reports',
  menu_path_type_preset: 'Preset',
  menu_path_type_datalab: 'Datalab',
  menu_path_type_pdf: 'PDF',
  menu_path_type_dashApp: 'Dash App',
  menu_path_type_custom: 'Customized',
  menu_path_type_public_url: 'Web Url',
  menu_path_type_cos_url: 'Cos Url',
  menu_path_type_looker: 'Looker',
  menu_path_type_out_url: 'Out Url',
  menu_path_type_out_path: 'Out Path',
  menu_path_type_auth_path: 'Auth Path',

  menu_path_placeholder: 'Please select link',
  menu_path_path_placeholder: 'Please select path',
  menu_path_tableau_placeholder: 'Please enter the tableau dashboard',
  menu_path_datalab_placeholder: 'Please enter the datalab dashboard',
  menu_path_preset_placeholder: 'Please enter the preset dashboard',
  menu_path_pdf_placeholder: 'Paste the PDF link or upload the PDF file',
  menu_path_dashApp_placeholder: 'Please enter the Dash App dashboard',
  menu_path_public_url_placeholder: 'Please enter the Web Url',
  menu_path_cos_url_placeholder: 'Please enter the Cos Url dashboard',
  menu_path_looker_placeholder: 'Please enter the looker dashboard',
  menu_path_out_url_placeholder: 'Please enter the Out Url',
  menu_path_out_path_placeholder: 'Please enter the Out path',
  menu_path_auth_path_placeholder: 'Please enter the Auth path',

  menu_name_null: 'Name must be filled in',
  menu_name_max_length_error: 'The content must contain less than 50 chars',
  menu_select_null: 'Menu must be selected',
  menu_folder_select_null: 'Folder must be selected',
  menu_subfolder_select_null: 'Subfolder must be selected',
  menu_user_level_select_null: 'Level must be selected',
  menu_path_webhook_url_select_null: 'Workbook Url must be selected',
  menu_path_path_select_null: 'Path Url must be selected',
  menu_path_datalab_null: 'Datalab must be filled in',
  menu_path_datalab_err: 'Please enter the correct datalab id',
  menu_path_preset_null: 'Preset must be filled in',
  menu_path_preset_err: 'Please enter the correct preset id',
  menu_path_url_null: 'Url must be filled in',
  menu_path_url_err: 'Please enter the correct Url',
  menu_auth_path_null: 'Auth path must be filled in',
  menu_auth_path_err: 'Please enter a valid Auth path',
  menu_pdf_url_err: 'Please enter the correct PDF Url',
  menu_dashApp_url_err: 'Please enter the correct dashApp Url',
  menu_pdf_url_null: 'PDF Url must be filled in',
  menu_pdf_format_err: 'The file format is incorrect, please upload a PDF',
  menu_pdf_uploaded_err: 'Upload failed, please upload again',
  menu_dashApp_url_null: 'Dash App Url must be filled in',
  menu_cos_url_null: 'Cos Url must be filled in',
  menu_cos_url_err: 'Please enter the correct Cos Url',
  menu_looker_url_err: 'Please enter the correct Looker Url',
  menu_looker_url_null: 'Looker Url must be filled in',
  menu_looker_models_null: 'Model(s) must be filled in',


  menu_folder_name_null: 'Folder Name must be filled in，and the  maximum length is 50 chars. ',
  menu_subfolder_name_null: 'Subfolder Name must be filled in，and the  maximum length is 50 chars. ',
  menu_menu_name_null: 'Menu Name must be filled in，and the  maximum length is 50 chars. ',
  menu_dashboard_name_null: 'Dashboard Name must be filled in，and the  maximum length is 50 chars. ',
  menu_must_contain_less: ' The content must contain less than 50 chars',


  menu_enter_menu_name: 'Please Enter Menu Name',
  menu_enter_menu_ch_name: 'Please Enter Menu Chinese Name',
  menu_enter_folder_name: 'Please Enter Folder Name',
  menu_enter_subfolder_name: 'Please Enter Subfolder Name',
  menu_enter_folder_ch_name: 'Please Enter Folder Chinese Name',
  menu_enter_subfolder_ch_name: 'Please Enter Subfolder Chinese Name',
  menu_Select: 'Please Select',
  menu_enter_dashboard_name: 'Please Enter Dashboard Name',
  menu_enter_dashboard_ch_name: 'Please Enter Dashboard Chinese Name',
  menu_select_no_data: 'No data available',

  menu_menu_re_enter: 'Menu Name already exists, please re-enter.',
  menu_folder_re_enter: 'Folder Name already exists, please re-enter.',
  menu_subfolder_re_enter: 'Subfolder Name already exists, please re-enter.',
  menu_dashboard_re_enter: 'Dashboard Name already exists, please re-enter.',
  menu_no_any_dashboard_exist: 'No dashboard is added for the current game',

  preset_ext_info_workspace_id_err: 'Please enter the correct workspace id',
  preset_ext_info_workspace_region_err: 'Please enter the correct workspace region',
  preset_ext_info_team_id_err: 'Please enter the correct team id',
  preset_ext_info_workspace_id_placeholder: 'Please enter the preset workspace id',
  preset_ext_info_workspace_region_placeholder: 'Please enter the preset workspace region',
  preset_ext_info_team_id_placeholder: 'Please enter the preset team id',

  looker_ext_info_models_placeholder: 'Please enter the looker model(s)',
  looker_ext_info_models_err: 'Please enter the correct model(s)',

  menu_extra_info: 'Extra Info',
  menu_extra_info_placeholder: 'Please Enter Extra Info, For Example: type=game&code=123',

  folder_info_name_err: 'Only Chinese characters, letters, numbers and special characters (- _ ( ) < > " “ & : ’：\') are supported for input.',
  
  menu_access_denied: 'Access Denied',
  menu_access_denied_button: 'I see',
  menu_access_denied_tips: 'Sorry, you do not have permission to access the current page. You have been automatically redirected to the accessible report.',
};
